// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.confirmation[data-v-012cc649] {\n  padding: 20px 30px;\n}\n.confirmation__btns-wrapper[data-v-012cc649] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin: 20px -5px 0;\n}\n.confirmation__btn[data-v-012cc649] {\n  width: auto;\n  margin: 0 5px;\n  padding: 0 10px;\n}\n", ""]);
// Exports
module.exports = exports;
